import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import useGuardianEventsCommunicationService, {
  GuardianEvent,
  GuardianMessage,
} from '../../../../apis/guardian/sub-apis/useGuardianEventsCommunicationService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';

type TQueryError = IFHError<{ message: string }>;

export const getGuardianEventsKey = 'get-guardian-events';
export const getGuardianMessagesKey = 'get-guardian-messages';

export const useGuardianEventsHook = (
  studentId: string,
  params: TPaginationParams & { type?: string; status?: string },
  options?: UseQueryOptions<{ data: GuardianEvent[]; count: number }, TQueryError>
): UseQueryResult<{ data: GuardianEvent[]; count: number }, TQueryError> => {
  const { getEvents } = useGuardianEventsCommunicationService();

  const safeParams = { ...params, page: params.page ?? 1, limit: params.limit ?? 10 };
  return useQuery<{ data: GuardianEvent[]; count: number }, TQueryError>({
    queryKey: [getGuardianEventsKey, studentId, safeParams],
    queryFn: () => getEvents(studentId, safeParams),
    enabled: !!studentId,
    ...options,
  });
};

export const useGuardianMessagesHook = (
  studentId: string,
  params: TPaginationParams & { read?: boolean; priority?: string },
  options?: UseQueryOptions<{ data: GuardianMessage[]; count: number }, TQueryError>
): UseQueryResult<{ data: GuardianMessage[]; count: number }, TQueryError> => {
  const { getMessages } = useGuardianEventsCommunicationService();

  const safeParams = { ...params, page: params.page ?? 1, limit: params.limit ?? 10 };
  return useQuery<{ data: GuardianMessage[]; count: number }, TQueryError>({
    queryKey: [getGuardianMessagesKey, studentId, safeParams],
    queryFn: () => getMessages(studentId, safeParams),
    enabled: !!studentId,
    ...options,
  });
};

